import React from 'react';
import EditIcon from '@mui/icons-material/Edit';
import GpsFixedIcon from '@mui/icons-material/GpsFixed';
import { Divider } from '@mui/material';

import { OptionalTooltip } from '@paragon/material';

import { useAppMonitor } from '../../../../monitor';
import { handleStandardSceneItemEditPropertiesAction } from '../../../../store/actions/sceneInteractionActions';
import { selectItems } from '../../../../store/actions/selectActions';
import { useAppDispatch, useAppSelector } from '../../../hooks';
import { SceneMenuContent } from '../common/SceneMenuContent';
import { SceneMenuItem } from '../common/SceneMenuItem';
import { DeleteMenuItem } from '../shared-menu-items/DeleteMenuItem';

export function TrussGroupMenu(props: { guid: string }) {
  const monitor = useAppMonitor();
  const dispatch = useAppDispatch();

  const trussGroup = useAppSelector((state) => state.trussGroups)[props.guid];
  const trussEnvelopes = useAppSelector((state) => state.layout.trussEnvelopes);

  if (trussGroup == null) return null;

  return (
    <SceneMenuContent>
      <SceneMenuItem
        text="Edit Properties"
        icon={<EditIcon />}
        onClick={() => {
          dispatch(handleStandardSceneItemEditPropertiesAction('trussGroup', trussGroup));
          monitor.recordInteraction('Truss Group => Edit Properties menu item clicked');
        }}
      />

      <OptionalTooltip title="Truss Group contains no envelopes" visible={trussGroup.trussEnvelopeGuids.length === 0}>
        <SceneMenuItem
          text="Switch to Truss Envelope Selection"
          icon={<GpsFixedIcon />}
          onClick={() => {
            dispatch(
              selectItems(
                trussGroup.trussEnvelopeGuids.map((trussEnvelopeGuid) => trussEnvelopes[trussEnvelopeGuid]),
                'trussEnvelope',
              ),
            );
            monitor.recordInteraction('Truss Group => Switch to Truss Envelope Selection menu item clicked');
          }}
          disabled={trussGroup.trussEnvelopeGuids.length === 0}
        />
      </OptionalTooltip>

      <Divider />

      <DeleteMenuItem type="trussGroup" item={trussGroup} />
    </SceneMenuContent>
  );
}
